export default __webpack_public_path__ + "static/media/monetary-fine.c8bcd0e7.svg";